<div [ngClass]="{'sticky--top': isStickyTop && stickyBehavior, 'sticky--bottom': !isStickyTop && stickyBehavior}"
	id="product-details"
	class="product__order">
	<div *ngIf="!isStickyTop"
		[@fade]
		class="bg-primary text-white px-md-5 py-3">
		<div class="container g-md-5 g-xxl-4">
			<div class="row">
				<div class="col-12 col-md-6 col-xl-3 order-md-2 d-flex flex-column justify-content-md-end">
					<div class="text-center text-md-start text-md-center lh-1 w-100">
						<span class="ff-spectral me-2">Price:</span>
						<span class="ff-spectral fs-3 fw-bold sku-price">
							{{sku.pricing.totals.net| currency: 'GBP'}}
						</span>
						<span class="small ms-2">
							+
							<span class="ms-2">VAT</span>
						</span>
						<!-- <span *ngIf="sku.pricing.algo">
							<br />New pricing
                            <br />
                            <table>
                                <tr>
                                    <td align="left">Pre discount</td>
                                    <td align="left">£{{sku.pricing.algo.preDiscount.net}}</td>
                                </tr>
                                <tr *ngIf="sku.pricing.algo.discountToUse !== 'none'">
                                    <td align="left">Discount ({{sku.pricing.algo.discountToUse}})</td>
                                    <td align="left">£{{sku.pricing.algo.discount[sku.pricing.algo.discountToUse].number}} ({{sku.pricing.algo.discount[sku.pricing.algo.discountToUse].percentage}}%)</td>
                                </tr>
                                <tr>
                                    <td align="left">Actual Price</td>
                                    <td align="left">£{{sku.pricing.algo.net}} (£{{sku.pricing.algo.vat}} VAT)</td>
                                </tr>
                            </table>

						</span> -->
					</div>
					<div class="d-flex justify-content-center">
						<button (click)="setOrder(true)"
                            *ngIf="product.allowSamples"
							class="d-md-none btn btn-outline-white btn-xs btn-md-100 align-self-center mt-3 mt-xl-2 mt-xxl-2 me-4">
							Order a free Sample
						</button>
						<button [ngClass]="{'disabled' : qty < product.minQty}"
							(click)="setOrder(false)"
							class="btn btn-white btn-xs btn-md-100 align-self-center mt-3 mt-xl-2 mt-xxl-2">
							Add to Basket
						</button>
					</div>
				</div>
				<div class="col-12 col-md-6 col-xl-3 order-md-1 d-none d-md-flex flex-column justify-content-md-end">
					<button (click)="setOrder(true)"
                        *ngIf="product.allowSamples"
						class="btn btn-outline-white btn-md-100 align-self-center mt-3 mt-xl-2 mt-xxl-2">
						Order a free Sample
					</button>
				</div>
				<div class="col-12 col-md-6 order-md-0 d-none d-xl-flex flex-column justify-content-center">
					<div class="ff-spectral fs-5 mb-3 mb-xl-1">
						Order today {{(publicTelNo$ | async) | strReplace: '+44': '0'}}
					</div>
					<div class="ff-spectral">
						Lines open Monday to Friday, 9am - 5pm
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isStickyTop"
		[@fade]
		class="bg-secondary text-white px-0 px-xs-2 px-md-5 py-3">
		<div class="container g-md-5 g-xxl-4">
			<div class="row">
				<div class="col-12 col-md-6 col-xxl-3 order-md-2 d-flex flex-md-column justify-content-between justify-content-md-end align-items-center align-items-md-start">
					<div class="text-start text-xs-center text-sm-start text-md-center lh-1 w-100">
						<span class="ff-spectral small me-2">Price:</span>
						<span class="ff-spectral fs-5 fw-bold">
							{{sku.pricing.totals.net | currency: 'GBP'}}
						</span>
						<span class="small ms-1 ms-md-2">
							+
							<span class="ms-0 ms-md-2">VAT</span>
						</span>
						<!-- <span *ngIf="sku.pricing.algo">
							: {{sku.pricing.algo.preDiscount.net}}
						</span> -->

                    </div>
					<button [ngClass]="{'disabled' : qty < product.minQty}"
						(click)="setOrder(false)"
						class="btn btn-thin btn-white btn-xs btn-md-100 align-self-center mt-0 mt-md-2">
						Add to Basket
					</button>
				</div>
				<div class="col-12 col-md-6 col-xxl-3 order-md-1 d-none d-md-flex flex-column justify-content-end">
					<button (click)="setOrder(true)"
                    *ngIf="product.allowSamples"
						class="btn btn-thin btn-outline-white btn-md-100 align-self-center mt-0 mt-md-2">
						Order a free Sample
					</button>
				</div>
				<div class="col-12 col-md-6 order-md-0 d-none d-xxl-flex flex-column justify-content-center">
					<div class="ff-spectral fs-5 mb-1 mb-xl-1">
						Order today {{(publicTelNo$ | async) | strReplace: '+44': '0'}}
					</div>
					<div class="ff-spectral">
						Lines open Monday to Friday, 9am - 5pm
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
